var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('app-chart',{attrs:{"type":'reader-chart',"title":'Reader Chart',"labels":_vm.labels,"data-sets":_vm.dataSets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }